import './index.scss';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useTus } from 'use-tus'
import { useDropzone } from "react-dropzone";
import axios, { CancelToken } from 'axios';
import Utils from '../../CourseApp/Helper/utils';
import {
    IconPlusSmallWhite,
    IconVideoFile,
    IconCross
} from '../../icons/svgs';
import manager from '../../Manager';

function VideoControl({ structure, saveValue, defaultValue, selectedSlide, controlKey, runtimeValue }) {
    const [controlValue, setControlValue] = useState(defaultValue ? defaultValue : {});
    const [percentCompleted, setpercentCompleted] = useState(0);
    const [fileData, setFileData] = useState();

    const { upload, setUpload } = useTus({ autoStart: true });
    const cancelFileUpload = useRef(null);
    const stateRef = useRef();
    const controlType = selectedSlide.data.platform === "files" && "video";

    const controlRules = structure?.rules;
    const controlRulesAllowedFileType = controlRules.allowedFileType ? controlRules.allowedFileType : ['.mp4'];
    const controlRulesMaxFileSize = controlRules.maxFileSize;
    const controlRulesMaxResolution = controlRules.maxResolution; // to be use
    const networkAccountId = manager.settings.networkAccountId;
    const baseUrl = manager.settings.baseUrl;
    const createVideoUrl = baseUrl + '/createVideo';
    const getVideoUrl = baseUrl + '/getVideo';
    const deleteVideoUrl = baseUrl + '/deleteVideo';
    const getQuotaCreatorAccount = baseUrl + '/getQuotaCreatorAccount';
    const bunnynetEndpoint = manager.settings.bunnynetEndpoint;
    const bunnynetCollectionIdNetworkAccount = manager.settings.bunnynetCollectionIdNetworkAccount;

    stateRef.current = upload;

    const onDrop = useCallback(async (acceptedFiles) => {
        const file = acceptedFiles[0];
        const validExtensions = controlRulesAllowedFileType;

        if (typeof file === 'undefined') {
            Utils.showError('allowed file type .' + validExtensions);
            return;
        }

        // Validasi tipe file
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        if (!validExtensions.includes(fileExtension)) {
            Utils.showError('allowed file type .' + validExtensions);
            return;
        }

        // validate file size
        if (file.size > controlRulesMaxFileSize) {
            Utils.showError('Maximum file size: ' + Utils.convertBytes(controlRulesMaxFileSize));
            return;
        }

        let fileRemainData = await fileRemain();
        if (file.size > fileRemainData) {
            Utils.showError('Storage not enough,\nremain ' + Utils.convertBytes(fileRemainData, 1));
            showModalStorageFull();
            return;
        }

        // upload to bunnynet
        handleUploadTus(file);
        saveValue({});
        selectedSlide.saveDisabled = true;
    });

    const showModalStorageFull = () => {
        window.jQuery('#tbcourse-modal-storage-full').modal('show');
    }

    const fileRemain = async () => {
        const { data } = await axios.post(getQuotaCreatorAccount, {
            networkAccountId: networkAccountId
        });
        return data.data.fileRemain;
    }

    const handleUploadTus = async (file) => {
        try {
            // step 1: create video
            let videoID = null;
            let bunnynetToken = null;
            let libraryId = null;
            let bunnynetExpirationTime = null;
            setpercentCompleted(.1);

            var config = {
                cancelToken: new CancelToken(
                    cancel => (cancelFileUpload.current = cancel)
                )
            };
            const { data } = await axios.post(createVideoUrl, {
                filename: file.name,
                collectionId: bunnynetCollectionIdNetworkAccount,
                networkAccountId: networkAccountId
            }, config);
            if (data.errCode === 0) {
                let responseData = data.data;
                videoID = responseData.guid;
                bunnynetToken = responseData.resAuthorizationSignature;
                bunnynetExpirationTime = responseData.resAuthorizationExpire;
                libraryId = responseData.videoLibraryId;
            }

            // step 2: upload video use videoID created
            if (videoID) {
                setFileData(file);
                setUpload(file, {
                    endpoint: bunnynetEndpoint,
                    retryDelays: [0, 3000, 5000, 10000, 20000, 60000, 60000],
                    headers: {
                        AuthorizationSignature: bunnynetToken, // SHA256 signature (library_id + api_key + expiration_time + video_id)
                        AuthorizationExpire: bunnynetExpirationTime, // Expiration time as in the signature,
                        VideoId: videoID, // The guid of a previously created video object through the Create Video API call
                        LibraryId: libraryId,
                    },
                    metadata: {
                        filename: file.name,
                        filetype: file.type,
                    },
                    onError: function (error) {
                        Utils.showError('An error occurred while uploading the file:' + error);
                        console.log(error);
                    },
                    onProgress: function (bytesUploaded, bytesTotal) {
                        var percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(0)
                        setpercentCompleted(percentage);
                    },
                    onSuccess: function (res) {
                        Utils.showLoading('Please wait until The video encoding has finished and the video is fully available');
                        getVideoData(videoID);
                    },
                });
            }

        } catch (error) {
            Utils.showError(error);
            console.log('Error', error);
        }
    }

    const getVideoData = async (guid) => {
        const { data } = await axios.post(getVideoUrl, {
            videoId: guid
        });
        if (data.errCode === 0) {
            let resultData = data.data;
            // https://docs.bunny.net/docs/stream-webhook
            if (resultData.status < 4) {
                setTimeout(async () => {
                    await getVideoData(resultData.guid);
                }, 1000);
            } else {
                setUpdateData(resultData, 0, false, true);
                selectedSlide.duration = resultData.length;
            }
        }
    }

    const handleUploadCancelTus = async () => {
        if (cancelFileUpload.current) {
            cancelFileUpload.current();
            setUpdateData(null, 0, false, false);
        }
        if (upload) {
            const headersVideoId = upload.options.headers.VideoId;
            upload.abort();
            const { data } = await axios.post(deleteVideoUrl, {
                videoId: headersVideoId
            });
            let resultData = data.data;
            if (data.errCode === 0 && resultData.success === true) {
                setUpdateData(null, 0, false, true);
            }
        }
    };

    const setUpdateData = (value, percent, disabled, dismissToast) => {
        let setValue = value !== null ? value : {};
        setControlValue(setValue);
        saveValue(setValue);
        setpercentCompleted(percent);
        selectedSlide.saveDisabled = disabled;
        if (dismissToast) {
            Utils.dismissAllToast();
        }
    }

    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'video/*': []
        },
        multiple: false,
        maxFiles: 1,
        onDrop,
    });

    const handleRemove = async () => {
        stateRef.current = "";
        await axios.post(deleteVideoUrl, {
            videoId: defaultValue.guid
        });
        setControlValue({});
        saveValue({});
        delete selectedSlide.data.thumbnails;
        selectedSlide.duration = selectedSlide.template.getDuration();
        Utils.showSuccess('File removed');
        setpercentCompleted(0);
    }

    // useEffect(() => {
    //     if (selectedSlide.data.thumbnails) {
    //         getVideoData(selectedSlide.data.video.guid);
    //     }
    // }, [selectedSlide.data.thumbnails]);

    useEffect(() => {
        if (typeof selectedSlide.data.video !== 'undefined') {
            setControlValue(selectedSlide.data.video);
        }
        else {
            setControlValue({});
        }
        // if (typeof defaultValue !== 'undefined') {
        //     setControlValue(defaultValue);
        // }
        // else {
        //     setControlValue({});
        // }
        // let thumbnails = selectedSlide.data?.thumbnails;
        // console.log('selectedSlide.data', selectedSlide.data);
        // console.log('thumbnails', thumbnails);
        // if (thumbnails) {
        //     console.log('lagi');
        //     let thumbnailImage = thumbnails[0]?.image;
        //     if (thumbnailImage) {
        //         let thumbnailImageFilename = thumbnailImage.filename;
        //         let thumbnailImageFullUrl = thumbnailImage.fullUrl;
        //         if (thumbnailImageFilename !== defaultValue.thumbnailFileName) {
        //             async function setThumbnail (){
        //                 const {data} = await axios.post(setVideoThumbnail, {
        //                     videoId: defaultValue.guid,
        //                     thumbnailUrl: thumbnailImageFullUrl,
        //                 });
        //                 return data;
        //             }
        //             let thumbnailResponse = setThumbnail();
        //             console.log('thumbnailResponse', thumbnailResponse);
        //         }
        //     }
        // }
    }, [defaultValue, selectedSlide]);

    return (
        structure.type === controlType && <>
            <div className="tbcourse-editor-control-item-label">
                {structure.labelOnChangeOption}
            </div>
            <div className="tbcourse-editor-control-attachment">
                {Object.keys(controlValue).length === 0 ? (
                    percentCompleted === 0 ? (
                        <div {...getRootProps()} className='dropzone-wrapper'>
                            <input {...getInputProps()} />
                            <div className='upload-area'>
                                <IconPlusSmallWhite />
                            </div>
                            <div className='placeholder-validation'>
                                Supported format, <span className='font-weight-700 text-dark'>{controlRulesAllowedFileType.join(', ')}</span>
                            </div>
                            <div className='placeholder-validation'>
                                Maximum upload file size <span className='font-weight-700 text-dark'>{Utils.convertBytes(controlRulesMaxFileSize, 0)}</span>
                            </div>
                        </div>
                    ) : (
                        <div className='progress-area'>
                            <div className='progress-upload'>
                                <progress className='progress-upload-value' value={percentCompleted} max="100" />
                                <div className='progress-upload-label'>{percentCompleted + ` %`}</div>
                            </div>
                            <div className='progress-upload-text'>
                                <div className='progress-upload-detail'>
                                    <div className='title'>{fileData?.name}</div>
                                    <div className='size'>Size {typeof fileData?.size !== 'undefined' ? Utils.convertBytes(fileData?.size, 1) : 'calculating'}</div>
                                </div>
                                <div className='progress-upload-cancel' onClick={handleUploadCancelTus}>Cancel</div>
                            </div>
                        </div>
                    )
                ) : (
                    <div className='upload-preview'>
                        <div className='preview-actions'>
                            <button type="button" className="btn btn-remove remove" onClick={handleRemove}>
                                <IconCross />
                            </button>
                        </div>
                        <div className='file-icon'>
                            <div className='file-icon-box'>
                                <IconVideoFile />
                            </div>
                        </div>
                        <div className='file-info'>
                            <div className='file-name' title={controlValue?.title}>{controlValue?.title}</div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
export default VideoControl;
